/*
 * *****************************************************************************
 *     Copyright (C)  Motorola Solutions, INC.
 *     All Rights Reserved.
 *     Motorola Solutions Confidential Restricted.
 * *****************************************************************************
 */

import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { MessageService } from './message.service';
import { Message } from 'CalltakingCoreApi';
import { StompManagerService } from '../../core/services/stomp-manager/stomp-manager.service';
import { Topic } from '../../user/model/multiple-subscriptions';

@Injectable({
  providedIn: 'root'
})
export class SystemLogMessageService extends MessageService {

    constructor(
        protected store: Store,
        protected stompManager: StompManagerService
    ) {
        super('SYSTEM', store, stompManager);
    }

    protected getTopics(): Topic[] {
        return [Topic.MESSAGES_SYSTEM_NEW, Topic.MESSAGES_SYSTEM_EDIT, Topic.MESSAGES_SYSTEM_DELETE];
    }

    protected getTopicHandlers(): { [topic in Topic]?: (message: any) => void } {
        return {
            [Topic.MESSAGES_SYSTEM_NEW]: this.newMessage.bind(this),
            [Topic.MESSAGES_SYSTEM_EDIT]: this.editMessage.bind(this),
            [Topic.MESSAGES_SYSTEM_DELETE]: this.deleteMessage.bind(this)
        };
    }

    protected effectsInitialized(): void {
    }

    protected websocketInitialized(): void {
    }

    protected deleteMessage(message: Message): void {
    }

    protected editMessage(message: Message): void {
        console.debug(`Server message: ${message.message}`);
    }

    protected newMessage(message: Message): void {
       console.debug(`Server message: ${message.message}`);
    }
}
